import { container } from "tsyringe";
export class UseCaseGetRenters {
    async handle() {
        const getRenters = container.resolve("iGetRenters");
        const renters = await getRenters.handle();
        return renters;
    }
}
